<sh-card>
  <api-call-gate [apiCall]="[systemDetails, gantryEvents]">
    <ng-template #lastSuccessfulData>
      <header slot="header" class="flex-row header--wrap">
        <sh-text class="logs" size="header-2">
          {{ 'cts.gantry.logs' | translate }}
        </sh-text>
        <app-cts-gantry-startup-event-filter
          id="cts-gantry-startup-event-filter-log-detail"
          [events]="events"
          [selectedEvent]="selectedEvent"
          (selectedEventChange)="onSelectedEventChange($event)"
        >
        </app-cts-gantry-startup-event-filter>
        <sh-text id="log-detail-gantry-version">
          {{ 'cts.gantry.version' | translate }} {{ softwareVersion }}
        </sh-text>

        <div class="space"></div>

        <app-cts-gantry-timezone-select
          [localDeviceOffset]="events[0]?.timestampOffset"
        ></app-cts-gantry-timezone-select>
      </header>

      <api-call-gate [apiCall]="gantryEventLogs">
        <ng-template #lastSuccessfulData>
          <div class="table-group">
            <div class="flex-row table-group__filter">
              <app-cts-gantry-filter-dropdown></app-cts-gantry-filter-dropdown>
              <sh-input-text
                id="log-detail-input-search"
                #searchInput
                (value-changed)="
                  filterLogService.onInputChange(searchInput.value)
                "
                label="{{ 'cts.gantry.search' | translate }}"
              >
                <sh-icon slot="icon" icon="search" size="s"></sh-icon>
              </sh-input-text>
            </div>

            <div class="table-container">
              <sh-table multiselect (scroll-end)="pagination.onScrollEnd()">
                <sh-table-row slot="header">
                  <sh-table-head min-width="65px" unsortable>
                    <div class="severity-icon">
                      <sh-icon
                        icon="information"
                        size="s"
                        color="rgb(var(--ui-5))"
                      ></sh-icon>
                    </div>
                  </sh-table-head>
                  <sh-table-head
                    id="log-detail-header-timestamp"
                    min-width="190px"
                    (toggle)="
                      filterLogService.onToggleSort(
                        'timestamp',
                        $event.target.hasAttribute('sort-descending')
                      )
                    "
                  >
                    {{ 'cts.gantry.table.dateTime' | translate }}
                  </sh-table-head>
                  <sh-table-head
                    id="log-detail-header-domainId"
                    min-width="136px"
                    (toggle)="
                      filterLogService.onToggleSort(
                        'domainId',
                        $event.target.hasAttribute('sort-descending')
                      )
                    "
                  >
                    {{ 'cts.gantry.table.domainId' | translate }}
                  </sh-table-head>
                  <sh-table-head
                    id="log-detail-header-message"
                    columns="24"
                    min-width="max-content"
                    (toggle)="
                      filterLogService.onToggleSort(
                        'message',
                        $event.target.hasAttribute('sort-descending')
                      )
                    "
                  >
                    {{ 'cts.gantry.table.message' | translate }}
                  </sh-table-head>
                </sh-table-row>

                @if (filteredLogs?.length > 0) {
                  @for (log of filteredLogs; track $index + log.domainId) {
                    <sh-table-row
                      [class.row--error]="log.severity === STATUS_ERROR"
                    >
                      <sh-table-cell min-width="65px">
                        <div class="severity-icon">
                          <sh-icon
                            icon="{{ log.severity.toLocaleLowerCase() }}"
                            size="s"
                          ></sh-icon>
                        </div>
                      </sh-table-cell>
                      <sh-table-cell class="datetime-cell" min-width="190px">
                        {{
                          log.timestamp
                            | ctsGantryTimezone: log.timestampOffset / 60
                        }}
                      </sh-table-cell>
                      <sh-table-cell min-width="136px">
                        {{ log.domainId }}
                      </sh-table-cell>
                      <sh-table-cell columns="24" min-width="max-content">
                        {{ log.message }}
                      </sh-table-cell>
                    </sh-table-row>
                  }
                } @else {
                  <app-cts-gantry-log-empty-state
                    id="cts-gantry-log-detail-empty-state"
                    [onlyErrorsMsg]="filterLogService.filter.errors"
                  ></app-cts-gantry-log-empty-state>
                }
              </sh-table>
            </div>
          </div>
        </ng-template>
      </api-call-gate>
    </ng-template>
  </api-call-gate>
</sh-card>
